import Curve from "components/UI/Animations/Curve/Curve";
import { QuizContext } from "context/QuizContext";
import { Fragment, useContext, useEffect, useState } from "react";
import QuizContent from "./components/QuizContent/QuizContent";

export default function Quiz() {
  const [animationDataStore, setAnimationDataStore] = useState<string | null>(
    null,
  );
  const [animationData, setAnimationData] = useState<string | null>("");

  const { currentCategory } = useContext(QuizContext);

  useEffect(() => {
    if (currentCategory) {
      setAnimationDataStore(currentCategory.image);
    }
  }, [currentCategory]);

  useEffect(() => {
    // need to use /* @vite-ignore */ to avoid vite from trying to import the file
    // before the build process
    // need to use to dynamically import json animation files for lottie
    // add this loading state to prevent a flicker of the old animation
    // when loading the next json file is being loaded
    setAnimationData(null);
    if (animationDataStore) {
      fetch(animationDataStore).then((res) => {
        res.json().then((data) => {
          setAnimationData(data);
        });
      });
    }
  }, [animationDataStore]);

  return (
    <>
      <Fragment key={`${currentCategory?.id}-${animationDataStore}`}>
        <Curve
          animationData={animationData!}
          color={currentCategory?.color}
          name={currentCategory?.name}
        >
          <QuizContent />
        </Curve>
      </Fragment>
    </>
  );
}
